import { render, staticRenderFns } from "./CheckGradient.vue?vue&type=template&id=2c310d5b&"
import script from "./CheckGradient.vue?vue&type=script&lang=ts&"
export * from "./CheckGradient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports